export default {
    namespaced: true,

    state: {
        activeTabIndex: null,
        tabs: [],
        activeSubtabIndex: null,
        subtabs: [],
    },

    getters: {
        tabs: state => state.tabs || [],
        subtabs: state => state.subtabs || [],
        activeTabIndex: state => state.activeTabIndex,
        activeSubtabIndex: state => state.activeSubtabIndex,
        activeTab: state => state.tabs[state.activeTabIndex],
        activeSubtab: state => state.subtabs[state.activeSubtabIndex],
    },

    mutations: {
        RESET(state) {
            state.activeTabIndex = null;
            state.tabs = [];
            state.activeSubtabIndex = null;
            state.subtabs = [];
        },
        TABS(state, payload) {
            state.tabs = payload;
        },
        SUBTABS(state, payload) {
            state.subtabs = payload;
        },
        ACTIVE_TAB_INDEX(state, payload) {
            state.activeTabIndex = payload;
        },
        ACTIVE_SUBTAB_INDEX(state, payload) {
            state.activeSubtabIndex = payload;
        },
    },

    actions: {
        doReset({ commit }) {
            commit('RESET');
        },
        setTabs({ commit }, tabs) {
            commit('TABS', tabs);
        },
        setSubtabs({ commit }, subtabs) {
            commit('SUBTABS', subtabs);
        },
        setActiveTabIndex({ commit }, index) {
            commit('ACTIVE_TAB_INDEX', index);
        },
        setActiveSubtabIndex({ commit }, index) {
            commit('ACTIVE_SUBTAB_INDEX', index);
        },
        resetTabs({ commit }) {
            commit('TABS', []);
            commit('ACTIVE_TAB_INDEX', null);
        },
        resetSubtabs({ commit }) {
            commit('SUBTABS', []);
            commit('ACTIVE_SUBTAB_INDEX', null);
        },
    },
};
